import React from 'react';
import PropTypes from 'prop-types';

const IconButton = (props) => {
    const { text, onClick, disabled, iconName, id } = props;
    return (
        <button
            type="button"
            className="btn btn-icon"
            onClick={onClick}
            id={id}
            disabled={disabled} >
            {iconName ? <i className={`icon ${iconName}`} aria-hidden="true"></i> : null}
            {text}
        </button>
    );
}

IconButton.propTypes = {
    text: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    iconName: PropTypes.string.isRequired
}

export default IconButton;



// WEBPACK FOOTER //
// ./src/components/common/IconButton/IconButton.js